import Vue from 'vue'
//import Vuetify, { VLayout, VCard, VDialog,VDivider, VAlert, VCardTitle, VCardText, VCardActions,VSpacer, VTooltip } from 'vuetify/lib'
import App from './App.vue'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'roboto-fontface'
import './assets/theme-overrides.css'
import router from './router'
import store from './store'
import './plugins/movableDialog'
import vuetify from './plugins/vuetify';
import './plugins';

Vue.config.productionTip = false;
// Vue.use(Vuetify, {
//     iconfont: 'mdi',
//     components: { VLayout, VCard, VDialog, VDivider,VAlert,VCardTitle, VCardText, VCardActions,VSpacer, VTooltip},
// });
let vm = new Vue({
    store,
    router,
    vuetify,
    el: '#app',
    render: h => h(App),
});

let init = () => {
    return Promise.all([
        store.dispatch('storeLangs'),
        store.dispatch('storeTranslations'),
    ]);
};

//init().then(() => vm.$mount('#app'));
init();
vm.$mount('#app');

